module.exports = __webpack_public_path__ + "static/camera2.8f1cd037.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/camera2.svg
// module id = 229
// module chunks = 35783957827783 95715928098905 172322841747965